export default __webpack_public_path__ + "static/dave-99243bcd4058d5504b7740d6860c2056.svg";